import { AnnotationSelectionRange, ClassAnnotation, ClassItem } from 'Types/Classes.types'
import classes from './TextAnnotationsTaskUI.module.less'
import { ArrowLeftOutlined, ArrowRightOutlined, CloseCircleFilled } from '@ant-design/icons'
import { TextAnnotationType } from 'Types/Tasks.types'
import React, { useCallback } from 'react'
import CommentIcon from 'Assets/icons/comment.svg'
import { isAlmostEqual } from 'Utils/common.utils'
import { useTaskContext } from 'Contexts/TaskContext'

type TextAnnotationsContentPropsType = {
    annotationsList: ClassAnnotation[]
    classList: ClassItem[]
    offset: { top: number; left: number; width: number }
    maxElementsInRow: number
    onClickDeleteAnnotations: (index: number) => void
    selectedClass: TextAnnotationType | null
    isCreatingAnnotation: boolean
    setCommentsAnnotationId: (annotationId: string | null) => void
    focusedAnnotationId: string | null
    setFocusedAnnotationId: (id: string | null) => void
    isReadOnly: boolean
}

export const TextAnnotationsContent: React.FC<TextAnnotationsContentPropsType> = (
    props: TextAnnotationsContentPropsType
) => {
    const { studio } = useTaskContext()
    const isCommentsEnabled =
        studio.taskConfig.assignment.task.config.text_annotations_config?.are_comments_enabled ??
        false

    const annotationsList = props.annotationsList.map(annotation => {
        return {
            id: annotation.id,
            class: props.classList.find(classItem => classItem.id === annotation.classId),
            ranges: annotation.selection.individualRowSelectionRange,
        }
    })

    const onHoverAnnotation = (annotationId?: string) => {
        if (annotationId && !props.isCreatingAnnotation) {
            props.setFocusedAnnotationId(annotationId)
        }
    }

    const showRightArrow = useCallback((ranges: AnnotationSelectionRange[], index: number) => {
        return ranges.length > 1 && index === 0
    }, [])

    const showLeftArrow = useCallback((ranges: AnnotationSelectionRange[], index: number) => {
        if (ranges.length === 1 || index === 0) {
            return false
        } else if (index === ranges.length - 1) {
            return !isAlmostEqual(ranges[index].positionStartY, ranges[index - 1].positionStartY)
        } else {
            return true
        }
    }, [])

    return (
        <div className={classes['annotations-container']}>
            {annotationsList.map((annotation, index1) => {
                if (!annotation.class?.isVisible) {
                    return null
                }
                return (
                    <React.Fragment key={index1}>
                        {annotation.ranges
                            .filter(range => range.positionWidth > 0)
                            .map((range, index2) => {
                                return (
                                    <React.Fragment key={index1 + '-' + index2}>
                                        <span
                                            className={
                                                classes['annotation-line'] +
                                                (props.isCreatingAnnotation
                                                    ? ' ' + classes['creating-annotation']
                                                    : '')
                                            }
                                            style={{
                                                top:
                                                    range.positionStartY -
                                                    props.offset.top +
                                                    34 -
                                                    28 * range.index,
                                                left: range.positionStartX - props.offset.left + 15,
                                                backgroundColor: annotation.class?.color,
                                                width: range.positionWidth,
                                            }}
                                            onMouseEnter={() => onHoverAnnotation(annotation.id)}
                                            onMouseLeave={() => props.setFocusedAnnotationId(null)}
                                        >
                                            <span
                                                className={
                                                    classes['annotation-label'] +
                                                    ' ' +
                                                    (range.positionStartX +
                                                        range.positionWidth +
                                                        155 >
                                                        props.offset.width + props.offset.left &&
                                                    range.positionWidth < 85
                                                        ? classes['right-align']
                                                        : '') +
                                                    ' ' +
                                                    (showRightArrow(annotation.ranges, index2)
                                                        ? classes['has-overflow']
                                                        : '')
                                                }
                                            >
                                                {showLeftArrow(annotation.ranges, index2) && (
                                                    <ArrowLeftOutlined
                                                        className={classes['annotation-left-arrow']}
                                                    />
                                                )}{' '}
                                                {annotation.class?.label}{' '}
                                                {props.focusedAnnotationId === annotation.id &&
                                                    !props.isReadOnly &&
                                                    index2 === 0 && (
                                                        <div
                                                            className={classes['actions-container']}
                                                        >
                                                            {isCommentsEnabled && (
                                                                <button
                                                                    onClick={() =>
                                                                        props.setCommentsAnnotationId(
                                                                            annotation.id
                                                                        )
                                                                    }
                                                                    className={
                                                                        classes['comment-icon']
                                                                    }
                                                                >
                                                                    <img src={CommentIcon} />
                                                                </button>
                                                            )}
                                                            <CloseCircleFilled
                                                                className={classes['delete-icon']}
                                                                onClick={() =>
                                                                    props.onClickDeleteAnnotations(
                                                                        index1
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    )}
                                            </span>
                                            <span className={classes['annotation-overflow-arrow']}>
                                                {showRightArrow(annotation.ranges, index2) && (
                                                    <ArrowRightOutlined />
                                                )}
                                            </span>
                                        </span>
                                        {props.focusedAnnotationId === annotation.id && (
                                            <span
                                                style={{
                                                    top:
                                                        range.positionStartY -
                                                        props.offset.top +
                                                        34,
                                                    left:
                                                        range.positionStartX -
                                                        props.offset.left +
                                                        15,
                                                    width: range.positionWidth,
                                                }}
                                                className={classes['annotation-gray-background']}
                                            ></span>
                                        )}
                                    </React.Fragment>
                                )
                            })}
                    </React.Fragment>
                )
            })}
        </div>
    )
}
